import styled from 'styled-components';

const TakeoverView = styled.div`
  bottom: 0;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
`;

export default TakeoverView;
